
























































































import Vue from 'vue'
import Component from 'vue-class-component'
import moment from 'moment'

import PageContent from '@app/componentlib/src/views/components/PageContent.vue'
import TopSearch from '@app/componentlib/src/views/jobsearch-pages/JobSearchTop.vue'
import JobResultList from '@app/componentlib/src/views/components/job-components/JobResultList.vue'
import JobDetailsView from '@app/componentlib/src/views/components/job-components/JobDetailsView.vue'
import JobResultSkeleton from '@app/componentlib/src/views/components/job-components/JobResultSkeleton.vue'
import JobSavedSearches from '@app/componentlib/src/views/jobsearch-pages/JobSavedSearches.vue'
import JobViewContainer from '@app/componentlib/src/views/components/job-components/JobViewContainer.vue'

import { AppModule } from '@app/componentlib/src/store/modules/app'
import { JobSearchModule } from '@app/componentlib/src/store/modules/jobSearch'
import { IJobPosting, IJobResult, IUserInfo, ISearchParams, ISettingsItem } from '@app/componentlib/src/common/types/JobSearchTypes'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'

@Component<JobSearchPage>({
  components: {
    PageContent,
    TopSearch,
    JobResultList,
    JobDetailsView,
    JobResultSkeleton,
    JobSavedSearches,
    JobViewContainer
  },
  props: {
    title: String,
    translations: Object,
    userInfo: Object,
    jobsFromPartners: Boolean,
    settings: Object
  }
})

export default class JobSearchPage extends Vue {
  /**
   * Props variables
   */
  title: string | undefined
  translations: object | undefined
  userInfo!: IUserInfo
  jobsFromPartners!: boolean
  settings: ISettingsItem | undefined

  /**
   * Component state variables
   */
  searchParams = JobSearchModule.searchParams as ISearchParams
  selectedMenu = "SearchPage"
  savedSearchName = ""

  jobPostings: IJobPosting[] = []
  tempJobPostings: IJobPosting[] = []

  searchCompleted: boolean = false
  isSearching: boolean = false
  startedSearch: boolean = false
  searchIsFromDatabase: boolean = false
  showOverlay: boolean = false
  mobileFiltersIsOpen: boolean = false
  gotTempFirstTime: boolean = false
  canSaveSearch: boolean = false
  savedMenuClicked: boolean = false
  savedSearchSearch: boolean = false
  savedSearchesRetrieved: boolean = false
  foundSavedWithSameName: boolean = false

  pageNumber: number = 0
  today = new Date()

  // Duplicate variables
  duplicateCounter: number = 0
  listToFilter: IJobPosting[] = []
  primaries: IJobPosting[] = []
  secondaries: IJobPosting[] = []

  /**
   * Lifecycle
   */
  async mounted() {
    if (this.translations !== undefined) {
      await AppModule.setTranslations(this.translations)
      await this.setDates()
    }

    await AppModule.init()
    await JobSearchModule.init()

    AppModule.setIsMobile(window.innerWidth)

    if (this.userInfo.languageCode !== "") moment.locale(this.userInfo.languageCode.split('-')[0])
    JobSearchModule.setUserInfo(this.userInfo)
    JobSearchModule.setJobsFromPartners(this.jobsFromPartners)

    if (this.jobsFromPartners === true)
      this.startSearch(true, false)
    else
      this.loadLastSearch()

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    await this.setSavedSearches()
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get jobResult (): IJobResult | undefined {
    return JobSearchModule.jobResult
  }

  get getJobPostings (): IJobPosting[] | undefined {
    return JobSearchModule.jobPostings
  }

  get savedSearches (): ISearchParams[] | undefined {
    return JobSearchModule.savedSearches
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  get activeIndex (): Number {
    return JobSearchModule.activeIndex
  }

  get selectedJobPosting (): IJobPosting | undefined {
    return JobSearchModule.selectedJobPosting
  }

  /**
   * Methods
   */
  async startSearch(newSearch: boolean, isFromSaved: boolean) {
    this.searchParams = JobSearchModule.searchParams

    // Sets current page to SearchPage, needed when searching from savedSearches
    this.selectedMenu = "SearchPage"
    this.savedSearchSearch = isFromSaved
    this.searchCompleted = false

    // If new search is true, reset values
    if (newSearch) {
      this.resetValues()
    }

    // Starts the actual search, and sets some variables
    await JobSearchModule.searchForJobs({'isInfiniteScroll': false, 'isFromSaved': this.savedSearchSearch}).finally(() => {
      this.startedSearch = false
      this.jobPostings = this.jobResult?.Results ? this.filterJobs(this.jobResult.Results) : []
      this.searchCompleted = true
      this.searchForMore()
    })
  }

  resetValues() {
    this.canSaveSearch = true
    this.startedSearch = true
    this.searchIsFromDatabase = false
    this.pageNumber = 0
    this.jobPostings = []
    this.tempJobPostings = []
    JobSearchModule.setSelectedJobPosting(undefined)
    this.duplicateCounter = 0
    this.gotTempFirstTime = false

    JobSearchModule.setJobPostings([])
    JobSearchModule.setTempSearchParams()
  }

  async searchForMore() {
    if (this.selectedMenu === 'SearchPage' && this.searchCompleted === true) {
      if (this.jobResult !== undefined && this.searchIsFromDatabase === false && this.searchParams.Page < this.jobResult.TotalPages-1) {
        // Get the second page for tempJobPostings from api
        if (
          this.gotTempFirstTime === false &&
          this.jobResult.TotalResults > 0 &&
          this.isSearching === false
        ) {
          this.isSearching = true
          await JobSearchModule.searchForJobs({'isInfiniteScroll': true, 'isFromSaved': this.savedSearchSearch}).finally(() => {
            this.isSearching = false
            this.tempJobPostings = this.jobResult?.Results ? this.filterCurrentJobsWithMoreJobs(this.jobResult?.Results) : []
            this.gotTempFirstTime = true
          })
        }
        // else, put tempJobPostings into jobPostings and get the next page for tempJobPostings
        else if (
          this.isSearching === false &&
          (this.jobResult.TotalResults - this.duplicateCounter) > this.jobPostings.length &&
          this.jobPostings.length > 0 && this.searchParams.Page < this.jobResult.TotalPages-1
        ) {
          this.isSearching = true

          JobSearchModule.setSearchParams(this.searchParams!)

          this.jobPostings = this.tempJobPostings

          if (this.searchParams.Page < this.jobResult.TotalPages-1)
            await JobSearchModule.searchForJobs({'isInfiniteScroll': true, 'isFromSaved': this.savedSearchSearch}).finally(() => {
              this.isSearching = false
              this.tempJobPostings = this.jobResult?.Results ? this.filterCurrentJobsWithMoreJobs(this.jobResult?.Results) : []
            })
          else
            this.isSearching = false
        }
      }
      else if (this.jobResult && this.searchIsFromDatabase === true) {
        this.loadLastSearch()
      }
    }
  }

  // Load the last search, used when page is initialy open
  async loadLastSearch() {
    if (this.isSearching === false && (this.pageNumber === 0 || (this.jobResult!.TotalResults - this.duplicateCounter) > this.jobPostings.length)) {
      if (this.jobPostings.length > 0)
        this.isSearching = true
      else
        this.startedSearch = true

      this.searchIsFromDatabase = true

      // get the first set of results if no jobs exists in jobPostings
      if (this.jobPostings.length <= 0) {
        await JobSearchModule.getLastSearch(this.pageNumber).finally(() =>  (
          this.searchCompleted = true,
          this.isSearching = false,
          this.startedSearch = false
        ))

        this.jobPostings = this.jobResult?.Results ? this.filterJobs(this.jobResult?.Results) : []
      }
      // Else, put tempjobPostings into jobPostings and get the next page for tempJobPostings
      else {
        this.jobPostings = this.tempJobPostings
        await JobSearchModule.getLastSearch(this.pageNumber+1).finally(() => this.isSearching = false)
        this.tempJobPostings = this.jobResult?.Results ? this.filterCurrentJobsWithMoreJobs(this.jobResult?.Results) : []
      }

      // Get the second page for tempJobPostings the first time
      if (this.gotTempFirstTime === false && this.jobResult && this.jobResult!.TotalResults > 100) {
        await JobSearchModule.getLastSearch(this.pageNumber+1).finally(() => this.isSearching = false)
        this.tempJobPostings = this.jobResult?.Results ? this.filterCurrentJobsWithMoreJobs(this.jobResult?.Results) : []
        this.gotTempFirstTime = true
      }

      this.pageNumber += 1
    }
  }

  clearSearch() {
    JobSearchModule.clearSearch()
    this.searchParams = JobSearchModule.searchParams
    LocationModule.setLocation([])
    this.canSaveSearch = false
  }

  emitParams() {
    this.searchParams = JobSearchModule.searchParams
  }

  //* SAVE SEARCH *//
  saveSearch() {
    this.foundSavedWithSameName = false

    this.savedSearches?.find(x => {
      if (x.SearchName.toLocaleLowerCase() === this.savedSearchName.toLocaleLowerCase()) {
        this.foundSavedWithSameName = true
      }
    })

    if (this.savedSearchName !== "" && this.foundSavedWithSameName === false) {
      JobSearchModule.saveSearch(this.savedSearchName).finally(() => {
        this.setSavedSearches()
        this.savedSearchName = ""
      })
      this.closeSaveSearchModal()
    }
  }

  async setSavedSearches() {
    this.savedSearchesRetrieved = false

    await JobSearchModule.getSavedSearches().finally(() => {
      this.savedSearchesRetrieved = true
    }).catch(() => this.savedSearchesRetrieved = true)
  }

  openSaveSearchModal() {
    this.$bvModal.show('modal-1')
  }

  closeSaveSearchModal() {
    this.$bvModal.hide('modal-1')
  }

  async deleteSavedSearch(id: number) {
    await JobSearchModule.deleteSavedSearch(id).finally(() => {
      this.setSavedSearches()
    })
  }
  //** SAVE SEARCH END  **/

  changeShowOverlay(bool: boolean) {
    if (this.isMobile === false)
      this.showOverlay = bool
    else
      this.showOverlay = false
  }

  changeMobileFiltersIsOpen(bool: boolean) {
    this.mobileFiltersIsOpen = bool
  }

  onResize(e: any) {
    if(e.currentTarget.innerWidth <= 768) {
      JobSearchModule.setSelectedJobPosting(undefined)
      JobSearchModule.setResizeDoneDesktop(false)
    } else if(e.currentTarget.innerWidth > 768) {
      if(JobSearchModule.resizeDoneDesktop === false) {
        JobSearchModule.setActiveIndex(0)

        JobSearchModule.setSelectedJobPosting(
          JobSearchModule.jobPostings !== undefined ? JobSearchModule.jobPostings[0] : undefined)

        JobSearchModule.setResizeDoneDesktop(true)
      }
    }

    AppModule.setIsMobile(e.currentTarget.innerWidth)
  }

  selectMenu(chosenMenu: string) {
    if (chosenMenu === 'SavedSearchesPage' )
      this.savedMenuClicked = true

    this.selectedMenu = chosenMenu
  }

  async setDates() {
    await JobSearchModule.setDates([
      {
        Id: 1,
        Name: this.t.jobSearch_V2_24_Hours,
        Date: new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 1).toString()
      },
      {
        Id: 2,
        Name: this.t.jobSearch_V2_One_Week,
        Date: new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 7).toString()
      },
      {
        Id: 3,
        Name: this.t.jobSearch_V2_Two_Weeks,
        Date: new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 14).toString()
      },
      {
        Id: 4,
        Name: this.t.jobSearch_V2_One_Month,
        Date: new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 30).toString()
      },
    ])
  }

  //** FILTERING JOBS START **//
  filterJobs (joblist: IJobPosting[]) {
    let listToFilter = this.initiateFilteringJobs(joblist)
    JobSearchModule.setJobPostings(listToFilter)
    return listToFilter
  }

  filterCurrentJobsWithMoreJobs (joblist: IJobPosting[]) {
    let listToFilter: IJobPosting[] = []
    let temppostlist = JobSearchModule.jobPostings ? JobSearchModule.jobPostings : []

    // Get the last hundred or less from last search
    listToFilter = temppostlist.length < 100 ? temppostlist : temppostlist.slice((temppostlist.length - 100, temppostlist.length))

    // Get the remaining jobs
    let newList = temppostlist.slice(0, temppostlist.length - listToFilter.length)

    // Filter through the old list and new list
    listToFilter = this.initiateFilteringJobs(listToFilter.concat(joblist))

    // Add the list with remaining jobs, and add the newly filtered list
    let getCurrentJobs = newList.concat(listToFilter) as IJobPosting[]
    JobSearchModule.setJobPostings(getCurrentJobs)
    return getCurrentJobs
  }

  initiateFilteringJobs (joblist: IJobPosting[]) {
    this.listToFilter = joblist

    // Filter primaries and secondaries
    this.primaries = this.listToFilter.filter(job => job.PrimaryAd === true)
    this.secondaries = this.listToFilter.filter(job => job.PrimaryAd === false)
    this.filterTwoLists(this.primaries, this.secondaries)

    // Filter out multiple secondaries, if no primaries are found
    this.secondaries = this.listToFilter.filter(job => job.PrimaryAd === false)
    this.filterTwoLists(this.secondaries, this.secondaries)

    return this.listToFilter
  }

  filterTwoLists(list: IJobPosting[], list2: IJobPosting[]) {
    for (let job in list) {
      for (let job2 in list2) {
        if(list[job] !== undefined && list2[job2] !== undefined) {
          if (list[job].JobId === list2[job2].JobId && list[job].Id !== list2[job2].Id) {
            // Get the index of the two iterated jobs, so it edits the correct jobs in the list
            let indexJob = this.listToFilter.findIndex(ad => ad === list[job])
            let indexJob2 = this.listToFilter.findIndex(ad => ad === list2[job2])

            if (indexJob !== undefined && indexJob2 !== undefined) {
              // Check if secondary is not company site and filter it out
              if (list2[job2].CompanySite === false)
                this.removeAndAddLink(indexJob, indexJob2)
              // If secondary is Company site filter out the primary
              else
                this.removeAndAddLink(indexJob2, indexJob)
            }
          }
        }
      }
    }
  }

  removeAndAddLink(indexToKeep: number, indexToRemove: number) {
    if(this.listToFilter[indexToKeep] !== undefined && this.listToFilter[indexToRemove] !== undefined ) {
      this.duplicateCounter += 1

      if (this.listToFilter[indexToRemove].NumberOfAds > 0)
        this.listToFilter[indexToKeep].NumberOfAds += this.listToFilter[indexToRemove].NumberOfAds

      if (this.listToFilter[indexToRemove].ListOfLinks.length > 0)
        this.listToFilter[indexToKeep].ListOfLinks.concat(this.listToFilter[indexToRemove].ListOfLinks)

      if (this.listToFilter[indexToRemove].Url !== undefined)
        this.listToFilter[indexToKeep].ListOfLinks.push(this.listToFilter[indexToRemove].Url)

      this.listToFilter[indexToKeep].NumberOfAds = this.listToFilter[indexToKeep].ListOfLinks.length

      this.listToFilter.splice(indexToRemove, 1)
    }
  }
  //** FILTERING JOBS END **//

  async setActiveIndex(index: number) {
    JobSearchModule.setActiveIndex(index)
  }

  async setSelectedJobPosting(posting: IJobPosting) {
    JobSearchModule.setSelectedJobPosting(posting)
  }
}
